import React from "react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogAction,
} from "./ui/alert-dialog";
import { ShieldAlert } from "lucide-react";

/**
 * Warning modal that appears `warningMs` before the inactivity logout fires.
 * Clicking "Stay logged in" calls stayLoggedIn() which resets the idle timer.
 */
export default function InactivityWarningDialog({ open, secondsLeft, onStay }) {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent data-testid="inactivity-warning">
        <AlertDialogHeader>
          <div className="flex items-center gap-2 text-amber-600 dark:text-amber-400 text-xs font-semibold uppercase tracking-wider">
            <ShieldAlert size={14} />
            Security
          </div>
          <AlertDialogTitle className="text-xl">
            You&apos;re about to be signed out
          </AlertDialogTitle>
          <AlertDialogDescription>
            For your security, the portal logs you out after 4 hours of
            inactivity. You&apos;ll be signed out in{" "}
            <span className="font-mono font-semibold text-foreground">
              {secondsLeft}
            </span>{" "}
            seconds.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction
            onClick={onStay}
            data-testid="inactivity-stay-logged-in"
          >
            Stay logged in
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
